"use strict";

var Reflux = require("reflux");
var agendorAPI = require("app/util/api/agendor-api");

var FunnelSelectFilterActions = Reflux.createActions({
  "loadFunnels": {children: ["completed", "failed"]}
});

FunnelSelectFilterActions.loadFunnels.listen(function(){
  agendorAPI.get("/funnels", null, function(funnels) {
    this.completed(funnels);
  }.bind(this));
});

module.exports = FunnelSelectFilterActions;



// WEBPACK FOOTER //
// ./app/shared/actions/funnel-select-filter-actions.js